type AtsModeLabelProps = {
	/** "Import from Jobylon", or the generic "Import from ATS" when the ATS name is unknown. */
	label: string
	atsName?: string | null
}

/**
 * In a narrow `@container`, the label drops its static text and shows only the ATS name, so a long
 * name like "SAP SuccessFactors" still fits next to the other modes. Screen readers always get the full label.
 */
export function AtsModeLabel({ label, atsName }: AtsModeLabelProps) {
	if (!atsName) {
		return <div>{label}</div>
	}

	return (
		<div title={label}>
			<span className="sr-only">{label}</span>
			<span aria-hidden="true" className="hidden @md:inline">{label}</span>
			<span aria-hidden="true" className="block max-w-[12rem] truncate @md:hidden">{atsName}</span>
		</div>
	)
}
